class AppSessionCapabilities {
  constructor(appSession, appUtils) {
    'inject';

    this._appSession = appSession;
    this._appUtils = appUtils;
  }
  getSession() {
    return this._appSession.getSession();
  }
  getPermissions() {
    const { account, application } = this.getSession();
    return Object.assign(
      {},
      account ? account.permissions : {},
      application ? application.permissions : {},
    );
  }
  hasPermissions(names, any = false) {
    const list = this._appUtils.ensureArray(names);
    const permissions = this.getPermissions();
    return any ?
      list.some((name) => permissions[name] === true) :
      !list.some((name) => permissions[name] !== true);
  }
  hasRoutePermissions(names) {
    return !names.some((name) => !this.hasPermissions(name, Array.isArray(name)));
  }
  isMe(userId) {
    return this.getSession().user.id === userId;
  }
}

export { AppSessionCapabilities };
